import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, message, Input, Form, Select } from "antd";
import { _uuid } from "../../utils/dataUtil";
import { getYesterdayDate } from "../../utils/dateUtil";
import { req_add_pim_staff_overtime_weekend } from "../../api";
import PicturesWall from "./pictures-wall";
import "./pictures-wall.css";

const Item = Form.Item;
class OvertimeStaffAddModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
    ip: PropTypes.string.isRequired,
  };
  state = {
    reasonList: [
      { label: "工作日加班", value: "工作日加班" },
      { label: "休息日加班", value: "休息日加班" },
    ],
    lock: false,
    selectedReason: "工作日加班",
    recordDescription: "",
    weekday: getYesterdayDate(),
    starttime: "1700",
    endtime: "1800",
    staffCode: "",
    row: {
      Uid: "",
      ClockType: "OVERTIME",
      StaffCode: "",
      OvertimeDate: "",
      OvertimekStart: "1700",
      OvertimeEnd: "1800",
      OvertimeReason: "工作日加班",
      ApplyStatus: "CY",
      OvertimeStatus: "WORK",
      RecordCreatorCode: this.props.user.userCode,
      RecordDescription: "",
      ReasonFileUrl: "",
    },
  };

  constructor(props) {
    super(props);
    this.get_overtime_images = React.createRef();
  }

  api_add_item_week_overtime = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_pim_staff_overtime_weekend(item, token);
    return result.status;
  };

  convertDateTime = (string_date, string_time) => {
    const year = string_date.substring(0, 4);
    const month = string_date.substring(4, 6);
    const day = string_date.substring(6, 8);
    const hours = string_time.substring(0, 2);
    const minutes = string_time.substring(2, 4);

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_btn_event = (tag, item) => {
    const {
      selectedReason,
      weekday,
      starttime,
      endtime,
      staffCode,
      recordDescription,
      row,
    } = this.state;
    switch (tag) {
      case "OverTimeApply":
        if (staffCode !== "") {
          if (this.checkTime(starttime, endtime)) {
            row.Uid = _uuid();
            row.OvertimeDate = weekday;
            row.OvertimeStart = starttime;
            row.OvertimeEnd = endtime;
            row.OvertimeReason = selectedReason;
            row.RecordDescription = recordDescription;
            row.StaffCode = staffCode.toUpperCase();

            const reasonFile = this.get_overtime_images.current.output_files();
            if (typeof reasonFile[0] === "undefined") {
              message.error("尚未上傳加班佐證資料");
            } else {
              if (reasonFile[0].indexOf("rc-upload") !== -1) {
                message.error("加班資料驗證失敗，請重傳");
              } else {
                row.ReasonFileUrl = reasonFile[0];
                //console.log(row); //row
                this.api_add_item_week_overtime(row).then((result) => {
                  if (result === "success") {
                    message.success("加班補登成功");
                    this.setState({ lock: true });
                  } else {
                    message.error("加班補登失敗");
                  }
                });
              }
            }
          }
        } else {
          message.error("請輸入正確職號");
        }
        break;
      default:
    }
  };

  checkTime = (starttime, endtime) => {
    // 檢查輸入是否為四位數字
    if (!this.validateInput(starttime) || !this.validateInput(endtime)) {
      message.error("請輸入四位數字的時間格式，例如0800");
      return false;
    }

    // 將輸入轉換為時間格式
    const startTime = parseInt(starttime.slice(0, 2));
    const startMinute = parseInt(starttime.slice(2, 4));
    const endTime = parseInt(endtime.slice(0, 2));
    const endMinute = parseInt(endtime.slice(2, 4));

    // 檢查時間是否有效
    if (
      !this.isValidTime(startTime, startMinute) ||
      !this.isValidTime(endTime, endMinute)
    ) {
      alert("時間格式錯誤，請確保時間在00:00至23:59之間");
      return false;
    }

    // 檢查起始時間是否早於結束時間
    if (
      !this.isStartTimeBeforeEndTime(startTime, startMinute, endTime, endMinute)
    ) {
      alert("起始時間不能晚於結束時間");
      return false;
    }
    return true;
  };

  validateInput = (input) => {
    return /^\d{4}$/.test(input);
  };

  // 驗證時間是否有效
  isValidTime = (hour, minute) => {
    return hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59;
  };

  // 檢查起始時間是否早於結束時間
  isStartTimeBeforeEndTime = (startHour, startMinute, endHour, endMinute) => {
    if (startHour < endHour) return true;
    if (startHour === endHour && startMinute < endMinute) return true;
    return false;
  };

  handleReasonChange = (value) => {
    //console.log(value);
    this.setState({ selectedReason: value });
  };

  ////////
  render() {
    const ReasonFileUrl = [];
    const fileUrlPath = "/api/UploadFile/AddInsideMediaFile";
    const { data } = this.props;
    const {
      weekday,
      starttime,
      endtime,
      selectedReason,
      reasonList,
      recordDescription,
      staffCode,
      lock,
    } = this.state;
    //console.log(data);
    return (
      <Card>
        <div>
          <Input
            placeholder="請輸入職工職號"
            value={staffCode}
            onChange={(e) => this.setState({ staffCode: e.target.value })}
          ></Input>
          <Input
            placeholder="請輸入加班日期"
            value={weekday}
            onChange={(e) => this.setState({ weekday: e.target.value })}
          ></Input>
          <Input
            placeholder="請輸入起始時間"
            value={starttime}
            onChange={(e) => this.setState({ starttime: e.target.value })}
          ></Input>
          <Input
            placeholder="請輸入結束時間"
            value={endtime}
            onChange={(e) => this.setState({ endtime: e.target.value })}
          ></Input>
          <Item
            label="加班補登分類"
            rules={[
              {
                required: true,
                whitespace: true,
                message: "必須填寫內容",
              },
            ]}
          >
            <Select
              defaultValue={selectedReason}
              onChange={this.handleReasonChange}
              style={{
                width: "100%",
              }}
              options={reasonList}
            />
          </Item>
          <PicturesWall
            ref={this.get_overtime_images}
            images_source={ReasonFileUrl}
            api_url={fileUrlPath}
            self_filename="加班證明圖檔"
          ></PicturesWall>
          <Input
            placeholder="請輸入加班原由"
            value={recordDescription}
            onChange={(e) =>
              this.setState({ recordDescription: e.target.value })
            }
          ></Input>
          <button
            className="btn btn-info btn-sm"
            style={{ width: "100%" }}
            onClick={() => this.handle_btn_event("OverTimeApply", data)}
            disabled={lock}
          >
            <i class="fas fa-user-clock" style={{ marginRight: "5px" }}></i>{" "}
            加班補登
          </button>
        </div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(OvertimeStaffAddModal);
